export default function parseDateStringIntoDateObj(passedDate){

    console.log("parseDate called with passedDate", passedDate)

    let date = new Date(passedDate);
    let utcConvertedDate =  Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    //let now = new Date();

    return new Date(utcConvertedDate /*+ now.getTimezoneOffset() * 60000*/);
}